let language = {
  SETTING_DEFAULT_SHIPPING_SAVE_ERROR_TITLE: 'Save error',
  SETTING_DEFAULT_SHIPPING_SAVE_ERROR_CONTENT: 'Failed to save. Please try again later!',
  SETTING_DEFAULT_SHIPPING_SAVE_ERROR_CONTENT_108000147: 'The list of default shipping methods is empty.',
  SETTING_DEFAULT_SHIPPING_SAVE_ERROR_CONTENT_108000159: 'The "enable" field is missing.',
  SETTING_DEFAULT_SHIPPING_SAVE_ERROR_CONTENT_108000148: 'The request body is missing.',
  SETTING_DEFAULT_SHIPPING_SAVE_ERROR_CONTENT_108000149: 'The store ID is empty.',
  SETTING_DEFAULT_SHIPPING_SAVE_ERROR_CONTENT_108000150: 'The store ID is invalid.',
  SETTING_DEFAULT_SHIPPING_SAVE_ERROR_CONTENT_108000160: 'The "enable" field is empty.',
  SETTING_DEFAULT_SHIPPING_SAVE_ERROR_CONTENT_108000141: 'The sort priority is missing.',
  SETTING_DEFAULT_SHIPPING_SAVE_ERROR_CONTENT_108000151: 'The default shipping method code is incorrect.',
  SETTING_DEFAULT_SHIPPING_SAVE_ERROR_CONTENT_108000152: 'The default shipping method code is duplicated.',
  SETTING_DEFAULT_SHIPPING_SAVE_ERROR_CONTENT_108000153: 'The sort priority is duplicated.',
  SETTING_DEFAULT_SHIPPING_SAVE_ERROR_CONTENT_108000154: 'The configuration for this store ID already exists.',

  SETTING_DEFAULT_SHIPPING_PAGE_TITLE: 'Default Shipping',
  SETTING_DEFAULT_SHIPPING_PAGE_DESC: 'Easily set a default shipping method for your shop so you don\'t have to update it manually for every customer order.',
  SETTING_DEFAULT_SHIPPING_RADIO_DISABLE: 'Disable',
  SETTING_DEFAULT_SHIPPING_RADIO_ENABLE: 'Enable (Select 3 shipping methods. If the first isn\'t available in the customer\'s region, the system will use the next available option.)',
  SETTING_DEFAULT_SHIPPING_PRIMARY_LABEL: 'Primary:',
  SETTING_DEFAULT_SHIPPING_SECONDARY_LABEL: 'Secondary:',
  SETTING_DEFAULT_SHIPPING_THIRD_LABEL: 'Third:',
  SETTING_DEFAULT_SHIPPING_SELECT_ONE_REQUIRED: 'Select at least one shipping method.',
  SETTING_DEFAULT_SHIPPING_CLEAR_SELECTION: 'Clear Selection',
  SETTING_DEFAULT_SHIPPING_SAVE_BUTTON: 'SAVE'
};
export { language };
